export interface VoiceMeta {
  /** ReadSpeaker API voice name — stored in the DB. */
  value: string;
  /** Human-readable label shown in the UI. */
  label: string;
  /** Gender indicator for UI grouping. */
  gender: 'male' | 'female';
}

export interface LanguageVoices {
  /** ReadSpeaker language code (e.g. 'nl_nl'). */
  lang: string;
  /** Human-readable label. */
  label: string;
  /** Sample sentence used for the voice preview button. */
  previewText: string;
  /** Available voices for this language. */
  voices: VoiceMeta[];
}

/**
 * Provisioned voice catalog per language.
 * Only DNN (neural) variants are exposed — they sound more natural
 * than the legacy concatenative voices.
 */
export const VOICE_CATALOG: LanguageVoices[] = [
  {
    lang: 'nl_nl',
    label: 'Nederlands',
    previewText: 'Hallo, dit is een voorbeeld.',
    voices: [
      { value: 'Ilse-DNN', label: 'Ilse', gender: 'female' },
      { value: 'Alex-DNN', label: 'Alex', gender: 'male' },
    ],
  },
  {
    lang: 'en_uk',
    label: 'English (UK)',
    previewText: 'Hello, this is an example.',
    voices: [
      { value: 'Alice-DNN', label: 'Alice', gender: 'female' },
      { value: 'Hugh-DNN', label: 'Hugh', gender: 'male' },
    ],
  },
];

/** Default language + voice used when no selection has been made. */
export const DEFAULT_VOICE = 'Ilse-DNN';
export const DEFAULT_LANG = 'nl_nl';
